// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 1.3.2 (commit 4b41cf3d71aa85cd4e75c96cbb54324481ee0b27).

/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import {
  AlgebraicType,
  AlgebraicValue,
  BinaryReader,
  BinaryWriter,
  ConnectionId,
  DbConnectionBuilder,
  DbConnectionImpl,
  Identity,
  ProductType,
  ProductTypeElement,
  SubscriptionBuilderImpl,
  SumType,
  SumTypeVariant,
  TableCache,
  TimeDuration,
  Timestamp,
  deepEqual,
  type CallReducerFlags,
  type DbContext,
  type ErrorContextInterface,
  type Event,
  type EventContextInterface,
  type ReducerEventContextInterface,
  type SubscriptionEventContextInterface,
} from "@clockworklabs/spacetimedb-sdk";
import { ProjectileInfo as __ProjectileInfo } from "./projectile_info_type";

export type Player = {
  id: number,
  objectId: number,
  name: string,
  maxHealth: number,
  health: number,
  speed: number,
  isFiring: boolean,
  attackAngle: number,
  isDead: boolean,
  isOnline: boolean,
  experience: number,
  level: number,
  maxExperience: number,
  identity: Identity,
  projectileInfo: __ProjectileInfo,
  x: number,
  y: number,
};

/**
 * A namespace for generated helper functions.
 */
export namespace Player {
  /**
  * A function which returns this type represented as an AlgebraicType.
  * This function is derived from the AlgebraicType used to generate this type.
  */
  export function getTypeScriptAlgebraicType(): AlgebraicType {
    return AlgebraicType.createProductType([
      new ProductTypeElement("id", AlgebraicType.createI32Type()),
      new ProductTypeElement("objectId", AlgebraicType.createI32Type()),
      new ProductTypeElement("name", AlgebraicType.createStringType()),
      new ProductTypeElement("maxHealth", AlgebraicType.createI32Type()),
      new ProductTypeElement("health", AlgebraicType.createI32Type()),
      new ProductTypeElement("speed", AlgebraicType.createI32Type()),
      new ProductTypeElement("isFiring", AlgebraicType.createBoolType()),
      new ProductTypeElement("attackAngle", AlgebraicType.createI32Type()),
      new ProductTypeElement("isDead", AlgebraicType.createBoolType()),
      new ProductTypeElement("isOnline", AlgebraicType.createBoolType()),
      new ProductTypeElement("experience", AlgebraicType.createI32Type()),
      new ProductTypeElement("level", AlgebraicType.createI32Type()),
      new ProductTypeElement("maxExperience", AlgebraicType.createI32Type()),
      new ProductTypeElement("identity", AlgebraicType.createIdentityType()),
      new ProductTypeElement("projectileInfo", __ProjectileInfo.getTypeScriptAlgebraicType()),
      new ProductTypeElement("x", AlgebraicType.createF32Type()),
      new ProductTypeElement("y", AlgebraicType.createF32Type()),
    ]);
  }

  export function serialize(writer: BinaryWriter, value: Player): void {
    Player.getTypeScriptAlgebraicType().serialize(writer, value);
  }

  export function deserialize(reader: BinaryReader): Player {
    return Player.getTypeScriptAlgebraicType().deserialize(reader);
  }

}


